import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Outlet } from 'react-router-dom'

const PublicRoutes = () => (
  <GoogleReCaptchaProvider language="es-AR" reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}>
    <Outlet />
  </GoogleReCaptchaProvider>
)

export default PublicRoutes
